var map = {
	"./template.betgalaxy": 1994,
	"./template.betgalaxy.tsx": 1994,
	"./template.betroyale": 1995,
	"./template.betroyale.tsx": 1995,
	"./template.default": 651,
	"./template.default.tsx": 651,
	"./template.fiestabet": 1996,
	"./template.fiestabet.tsx": 1996,
	"./template.puntcity": 1997,
	"./template.puntcity.tsx": 1997,
	"./template.questbet": 1998,
	"./template.questbet.tsx": 1998,
	"./template.ts": 728,
	"./template.volcanobet": 1999,
	"./template.volcanobet.tsx": 1999,
	"./template.wellbet": 2000,
	"./template.wellbet.tsx": 2000
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2291;